import { schema } from 'normalizr';

const transactionSchema = new schema.Entity('transaction');

export default transactionSchema;
